import React from 'react';
import { ShieldExclamationIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const RISK_STYLES = {
  LOW: {
    bg: 'bg-emerald-50 dark:bg-emerald-500/20',
    text: 'text-emerald-600 dark:text-emerald-400',
    dot: 'bg-emerald-500',
  },
  MEDIUM: {
    bg: 'bg-amber-50 dark:bg-amber-500/20',
    text: 'text-amber-600 dark:text-amber-400',
    dot: 'bg-amber-500',
  },
  HIGH: {
    bg: 'bg-red-50 dark:bg-red-500/20',
    text: 'text-red-600 dark:text-red-400',
    dot: 'bg-red-500',
  },
};

export default function RiskBadge({ level = 'LOW', score, showScore = false }) {
  const styles = RISK_STYLES[level] || RISK_STYLES.LOW;
  const label = level === 'LOW' ? 'Low' : level === 'MEDIUM' ? 'Medium' : 'High';

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] rounded-full font-medium ${styles.bg} ${styles.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${styles.dot}`} />
      <span>{label}</span>
      {showScore && score !== undefined && (
        <span className="opacity-50 font-normal">{score}</span>
      )}
    </span>
  );
}
